import React from 'react';

const Topbar = () => (
  <div id="home" className="top-header">
    <div className="container">
      <div className="row">
        <div className="col-xl-5 col-lg-6 col-md-8 col-sm-12 col-12 d-none d-xl-block d-lg-block d-md-block">
          <p>#1 Paladion - AI Driven MDR for High Speed Cyber Defense</p>
        </div>
        <div className="col-xl-7 col-lg-6 col-md-4 col-sm-12 col-12 d-flex justify-content-end">
          <ul className="list-unstyled">
            <li className="d-none d-xl-block d-lg-block">
              <i className="fa fa-headphones-alt mr-2" />
              <a href="#contact">Request a Free Demo</a>
            </li>
            <li>
              <i className="fa fa-phone fa-fw mr-2 " />
Call: +91-80-42543444
            </li>
            {/* <li className="d-xl-block d-lg-block d-md-none">
              <i className="fa fa-comments fa-fw mr-2 text-brand " />
              {' '}
              <a href="/">Chat with us</a>
            </li> */}
          </ul>
        </div>
      </div>
    </div>
  </div>

);

export default Topbar;
